import { render, staticRenderFns } from "./AdvertsDetails.vue?vue&type=template&id=31edbc82&scoped=true&"
import script from "./AdvertsDetails.vue?vue&type=script&lang=js&"
export * from "./AdvertsDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdvertsDetails.vue?vue&type=style&index=0&id=31edbc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31edbc82",
  null
  
)

export default component.exports